import axios from "axios";
import AWS from "aws-sdk";
import { getCurrentUser, getUserToken } from "../../helpers/utils";
import { MAIN_URL } from "./URLs";

const configureAxios = () => {
  axios.defaults.baseURL = MAIN_URL;
  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
  // const token = getUserToken();
  const token = "c53bd9e7b49cf2ffeb57a33fa38ce493382a5d882";
  setAxiosToken(token);
};

const setAxiosToken = (token) => {
  if (token) {
    axios.defaults.headers.common["token"] = token;
  } else {
    delete axios.defaults.headers.common["token"];
  }
};

// AWS Related
let BucketCredentials = {};

let awsBucket = {};

const updateAWSCredentials = (awsCredential) => {
  BucketCredentials = awsCredential;
  AWS.config.update({
    accessKeyId: awsCredential.accessKeyId,
    secretAccessKey: awsCredential.secretAccessKey,
  });
  awsBucket = new AWS.S3({
    params: { Bucket: awsCredential.bucketName },
    region: awsCredential.region,
  });
};

export {
  axios,
  configureAxios,
  awsBucket,
  updateAWSCredentials,
  BucketCredentials,
};
